module.exports = __webpack_public_path__ + "img/30.10.pH.243f5e0e.png";